import axios from "@/axios";

const userApi = {
  Login: '/api/pad/auth/login',
  Logout: '/api/pad/auth/logout',
  UserInfo: '/api/pad/auth/profile',
}

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
  return axios({
    url: userApi.Login,
    method: 'post',
    data: parameter,
  })
}

export function getInfo1111() {
  return axios({
    url: userApi.UserInfo,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  })
}

export function getInfo(parameter) {
  return axios({
    url: userApi.UserInfo,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
	data: parameter,
  })
}

export function logout(parameter) {
  return axios({
    url: userApi.Logout,
    method: 'post',
	data: parameter,
  })
}
